import { CreateMobileAVResourceForm } from "../../resourcesTypes"

type FieldKey = keyof CreateMobileAVResourceForm

export enum TabsOrder {
    GENERAL,
    ACCESS_CONTROL,
    NOTIFICATIONS,
    AVAILABILITY,
}

export const fieldTabMap: { [field in FieldKey]: TabsOrder } = {
    isActive: TabsOrder.GENERAL,
    name: TabsOrder.GENERAL,
    image: TabsOrder.GENERAL,
    description: TabsOrder.GENERAL,
    accessControl: TabsOrder.ACCESS_CONTROL,
    buffer: TabsOrder.GENERAL,
    color: TabsOrder.GENERAL,
    closingTimes: TabsOrder.AVAILABILITY,
    avDetails: TabsOrder.GENERAL,
    tags: TabsOrder.GENERAL,
    notifications: TabsOrder.GENERAL,
    bookingTime: TabsOrder.AVAILABILITY,
    closingTimesDaily: TabsOrder.AVAILABILITY,
    isClosingTimes: TabsOrder.AVAILABILITY,
    isBookingTime: TabsOrder.AVAILABILITY,
    bookingTimeType: TabsOrder.AVAILABILITY,
}
